document.addEventListener("DOMContentLoaded", function () {
    var accordions = document.querySelectorAll(".jscustomaccordion");

    accordions.forEach(function (accordion) {
        var headings = accordion.querySelectorAll("h2");

        headings.forEach(function (heading, index) {
            heading.setAttribute("role", "button");
            heading.setAttribute("tabindex", "0");
            heading.setAttribute("aria-expanded", "false");
            heading.classList.add("accordion__title");

            // Sammle alle Content-Nodes zwischen diesem <h2> und dem nächsten <h2>
            var contentElements = [];
            var next = heading.nextElementSibling;

            while (next && next.tagName.toLowerCase() !== "h2") {
                contentElements.push(next);
                next = next.nextElementSibling;
            }

            // Anfangszustand: alles geschlossen
            contentElements.forEach(function (el) {
                el.style.display = "none";
                el.classList.add("accordion__content");
            });

            function toggleAccordion() {
                var isExpanded = heading.getAttribute("aria-expanded") === "true";
                heading.setAttribute("aria-expanded", String(!isExpanded));
                heading.classList.toggle("toggle-active", !isExpanded);
                heading.classList.toggle("toggle", isExpanded);

                contentElements.forEach(function (el) {
                    el.style.display = isExpanded ? "none" : "block";
                });
            }

            // Klick-Event
            heading.addEventListener("click", toggleAccordion);

            // Tastatursteuerung (Enter / Space)
            heading.addEventListener("keydown", function (e) {
                if (e.key === "Enter" || e.key === " " || e.code === "Space") {
                    e.preventDefault();
                    toggleAccordion();
                }
            });
        });
    });
});